import { Button, Icon, Popconfirm } from 'antd';
import classNames from 'classnames/bind';
import { getPropsFromUrl } from 'components/hoc';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { emptyFn } from 'utils/common';
import { revertSlots, tryUpdateDashboard } from '../flow/actions';
import styles from '../index.less';

const cx = classNames.bind(styles);

const defaultProps = {
  tryUpdateDashboard: emptyFn,
  revertSlots: emptyFn
};
const propTypes = {
  dashboardId: PropTypes.string.isRequired,
  isInvalid: PropTypes.bool.isRequired,
  isRevertable: PropTypes.bool.isRequired,
  revertSlots: PropTypes.func,
  tryUpdateDashboard: PropTypes.func
};

const Actions = ({
  dashboardId,
  dashboardFolderId,
  isInvalid,
  isRevertable,
  revertSlots,
  tryUpdateDashboard,
  history
}) => (
  <div style={{ position: 'relative' }}>
    <div className={cx('btnsWrapper')}>
      <Button
        className={`${cx('floatBtn')} mb-sm`}
        disabled={isInvalid}
        onClick={() =>
          tryUpdateDashboard(dashboardId, dashboardFolderId, history.replace)
        }
      >
        <Icon type="save" />
      </Button>
      <Popconfirm
        title={<FormattedMessage id="global.ui.dialog.revertTitle" />}
        onConfirm={revertSlots}
        placement="left"
      >
        <div>
          <Button
            className={`${cx('floatBtn')} mb-sm report-theme-btn`}
            disabled={!isRevertable}
          >
            <Icon type="reload" />
          </Button>
        </div>
      </Popconfirm>
    </div>
  </div>
);

const mapStateToProps = ({ global, dashboardSettings }) => ({
  lang: global.language,
  isRevertable: dashboardSettings.details.slots.some(s => s.isRevertable()),
  isInvalid:
    dashboardSettings.details.slots.some(s => !s.isValid()) ||
    dashboardSettings.details.title === ''
});
const mapDispatchToProps = {
  tryUpdateDashboard,
  revertSlots
};
Actions.defaultProps = defaultProps;
Actions.propTypes = propTypes;

const enhancers = compose(
  withRouter,
  getPropsFromUrl(['dashboardId', 'dashboardFolderId']),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
);
export default enhancers(Actions);



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Details/components/Actions.jsx